import React from 'react';
import { useTranslation } from 'react-i18next/';

import Form from 'src/components/Form/Form';

function FicaForm() {
  const { t } = useTranslation('common');


  const steps = [{
    label: t('form.personalLabel'),
    inputs: [
      {
        type: 'text',
        className: 'col2',
        placeholder: 'ZAR',
        label: t('form.amountOfTransaction'),
        name:'transactionAmount'
      },
      {
        type: 'text',
        className: 'col2',
        label: t('form.transactionType'),
        name: 'transactionType',
        placeholder: t('form.transactionType')
      },
      {
        type: 'time',
        className: 'col2',
        placeholder: 'HH:MM:ss',
        label: t('form.time'),
        name: 'time'
      },
      {
        type: 'date',
        className: 'col2',
        placeholder: 'DD/MM/YYYY',
        label: t('form.date'),
        name: 'date',
        defaultValue: Date.now()
      },
      {
        type: 'text',
        className: 'full-width',
        label: t('form.reference'),
        name: 'reference',
        placeholder: t('form.referencePlaceholder')
      },
      {
        type: 'text',
        className: 'col2',
        label: t('form.firstName'),
        name: 'firstName',
        placeholder: t('form.lastNamePlaceholder')
      },
      {
        type: 'text',
        className: 'col2',
        label: t('form.lastName'),
        name: 'lastName',
        placeholder: t('form.lastNamePlaceholder')
      },
      {
        type: 'text',
        className: 'full-width',
        label: t('form.address'),
        name: 'address',
        placeholder: t('form.addressPlaceholder')
      },
      {
        type: 'text',
        className: 'col2',
        label: t('form.contact'),
        name: 'contact',
        placeholder: t('form.contactPlaceholder')
      },
      {
        type: 'text',
        className: 'col2',
        label: t('form.idNumber'),
        name: 'idNumber',
        placeholder: t('form.idNumberPlaceholder')
      }
    ],
    buttons: [
      {
        type: 'submit',
        label: t('form.submit')
      }
    ]
  }];
  return (
    <Form
      containerClass="fica-form"
      steps={ steps }
      close={ close }
    />
  );
}

export default FicaForm;
